module.exports = __webpack_public_path__ + "img/technique-detail.853daac8.jpg";